import { render, staticRenderFns } from "./MortgagesStatus.vue?vue&type=template&id=027a54c5&"
import script from "./MortgagesStatus.vue?vue&type=script&lang=ts&"
export * from "./MortgagesStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports